import { jsonFetch } from './../utils/fetch';
import { urls } from './../config';

const getLangTest = () => jsonFetch(urls.langTest);
const nextStep = data => jsonFetch(`${urls.langTest}`, data, { method: 'POST' });

export default {
  getLangTest,
  nextStep,
};



// WEBPACK FOOTER //
// ./src/api/languageTest.js